module.exports = __webpack_public_path__ + "fonts/mountain.svg?v=80d344e32da76c17109b32ce48412937";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mountain.svg
// module id = 695
// module chunks = 0